import React, { useState } from 'react';
import { Box, Flex, Text } from 'rebass';

export const useTabs = ({
  tabs,
  verticalTabControls,
  tabControlProps: {
    noBorder = false,
    ...tabControlProps
  } = {},
  defaultSelectTab = 0,
}) => {
  const [selectedTab, setSelectedTab] = useState(defaultSelectTab);

  const renderHorizontalTabControls = () => (
    <Flex
      alignItems="center"
      my={3}
      css={`
        /* gap: 20px; */
        margin: 10px 0;
        ${!noBorder && 'border-bottom: 1px solid var(--borderNeutralMutedAlpha);'}
      `}
      {...tabControlProps}
    >
      {tabs.map((tab, index) => (
        <Text
          key={tab.label}
          as="button"
          fontWeight="bold"
          color={index === selectedTab ? `var(--textNeutral)` : `var(--textNeutralSubtle)`}
          px={3}
          py={[3, 4]}
          fontSize={1}
          onClick={() => setSelectedTab(index)}
          css={`
            margin-bottom: -1px;
            cursor: pointer;
            background: transparent;
            border: none;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;

            &:hover {
              background: var(--backgroundHover);
            }
            border-bottom: 2px solid ${index === selectedTab ? `var(--orange300)` : `transparent`};
          `}
        >
          {tab.label}
        </Text> 
      ))}
    </Flex>
  );

  const renderVerticalTabControls = () => (
    <Box
      alignItems="center"
      my={3}
      css={`
        border: 1px solid var(--borderNeutralMutedAlpha);
        border-radius: 8px;
        overflow: hidden;
      `}
      {...tabControlProps}
    >
      {tabs.map((tab, index) => (
        <Text
          key={tab.label}
          as="button"
          fontWeight="bold"
          color={index === selectedTab ? `var(--textNeutral)` : `var(--textNeutralSubtle)`}
          px={3}
          py="14px"
          fontSize={1}
          onClick={() => setSelectedTab(index)}
          css={`
            display: block;
            width: 100%;
            text-align: left;
            cursor: pointer;
            background: var(--background);
            border: none;

            &:hover {
              background: var(--backgroundHover);
            }
            box-shadow: 2px 0 0 ${index === selectedTab ? `var(--orange300)` : `transparent`} inset;
            border-bottom: 1px solid var(--borderNeutralMutedAlpha);

            &:last-child {
              border-bottom: none;
            }
          `}
        >
          {tab.label}
        </Text> 
      ))}
    </Box>
  );

  return ({
    tabControls: verticalTabControls ? renderVerticalTabControls() : renderHorizontalTabControls(),
    verticalTabControls: renderVerticalTabControls(),
    horizontalTabControls: renderHorizontalTabControls(),
    tabContent: tabs[selectedTab].render(),
  });
};

const Tabs = ({ tabs }) => {
  const { tabControls, tabContent } = useTabs(tabs);
  
  return (
    <Box>
      {tabControls}
      {tabContent}
    </Box>
  );
}

export default Tabs;